import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import { apiConfig } from '../../lib/apiConfig';
import './PublicationDetail.css';

// Déséchapper le HTML si besoin
function decodeHtml(html) {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

export default function PublicationDetail() {
  const { id } = useParams();
  const [publication, setPublication] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchPublication() {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${apiConfig.publicationBase}/publications/${id}`);
        const data = await res.json();
        if (data && data.success && data.data) {
          setPublication(data.data);
        } else {
          setError('Publication introuvable');
        }
      } catch (e) {
        setError('Erreur lors du chargement');
      } finally {
        setLoading(false);
      }
    }
    if (id) fetchPublication();
  }, [id]);

  if (loading) return <div>Chargement…</div>;
  if (error) return <div style={{color:'#b91c1c',padding:16}}>{error}</div>;
  if (!publication) return null;

  return (
    <div>
      <Header />
      <Navbar />
      <div className="publication-detail container card">
        <Link to="/publications" className="btn-back">← Retour</Link>
        <h2>{publication.title}</h2>
        <div style={{margin:'16px 0', color:'#64748b'}}>
          {publication.category && <span style={{marginRight:8}}>{publication.category}</span>}
          {publication.publishedAt && <span>Publié le {new Date(publication.publishedAt).toLocaleDateString()}</span>}
        </div>
        <div style={{background:'#fff', border:'1px solid #e2e8f0', borderRadius:10, padding:'16px 18px'}}
          dangerouslySetInnerHTML={{
            __html: /&lt;|&gt;|&amp;/.test(publication.body || publication.description || '')
              ? decodeHtml(publication.body || publication.description || '')
              : (publication.body || publication.description || '')
          }}
        />
        {publication.attachments && publication.attachments.length > 0 && (
          <div style={{marginTop:16}}>
            <h4>Pièces jointes</h4>
            <ul>
              {publication.attachments.map((att, idx) => (
                <li key={idx}><a href={att.dataUrl || att.url} target="_blank" rel="noreferrer">{att.name}</a></li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
